// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"d1fda171","150":"2b0ca6cd","455":"561a46c5","488":"b3a402ed","508":"86b313e4","977":"cc4735f2"}[chunkId] + ".chunk.js";
};